import React from "react";
import { Text, Icon, Button } from "@ilc-technology/luik";
import { LabelKey } from "../../../Common/StoryblokTypes";
import Surface from "../../Surface/Surface";
import { AppStoreButton, GooglePlayButton } from "react-mobile-app-button";
import { useSessionContext } from "../../../contexts/SessionContext/SessionContext";
import { useDatasources } from "../../../contexts/StoryblokContext/StoryblokContext";
import { getCampusConnectAppStoreUrl, getCampusConnectGooglePlayUrl, getCampusConnectMobileAppUrl } from "./helpers";

const QR_CODE_IMG_URL =
  "https://media.ef.com/1fiddy7nnhpbrqojw74qvh62j_sYmUxYWM0OWNjNmZhNDRh/campus-connect-qr-110x110.webp";
const BACKGROUND_IMG_URL =
  "https://media.ef.com/1fipmtjEz8FdXhovCbEEtuzww_sZTBkZWI4MTc0NjcyMDIy/post-summary-bg-raw.webp";

const PostSubmissionContent: React.FC = () => {
  const { labels } = useDatasources();
  const { session } = useSessionContext();
  const userMarket = session.user.market;

  const bulletPoints = [
    labels[LabelKey.downloadCampusConnectBulletPoint_1],
    labels[LabelKey.downloadCampusConnectBulletPoint_2],
    labels[LabelKey.downloadCampusConnectBulletPoint_3],
    labels[LabelKey.downloadCampusConnectBulletPoint_4],
  ].filter(Boolean);

  return (
    <Surface data-testid="post-submission-content" className="mb-8 flex flex-col overflow-hidden lg:flex-row-reverse">
      <div className="flex flex-col justify-between gap-4">
        <div>
          <Text variant="label-sm" className="hidden lg:flex">
            {labels[LabelKey.postReservationCampusConnectSection_eyebrowText]}
          </Text>
          <Text variant="heading-3-bold">{labels[LabelKey.postReservationCampusConnectSection_title]}</Text>
          {bulletPoints.length > 0 && (
            <ul className="list-disc py-2 pl-5">
              {bulletPoints.map((text, index) => (
                <li key={index}>{text}</li>
              ))}
            </ul>
          )}
        </div>

        <div>
          <Button
            className="flex lg:hidden"
            onPress={() => window.open(getCampusConnectMobileAppUrl(userMarket), "_blank")}
          >
            {labels[LabelKey.postReservationCampusConnectSection_getAppCtaLabel]}
          </Button>
          <div className="hidden gap-4 lg:flex">
            <img className="w-32" src={QR_CODE_IMG_URL} alt="Campus Connect QR Code" />
            <div className="flex flex-col justify-center gap-4">
              <Icon size="sm" iconName="arrow-left" aria-hidden={true} />
              <Text variant="label-lg-bold">{labels[LabelKey.postReservationCampusConnectSection_qrCodeLabel]}</Text>
            </div>
          </div>
        </div>
        <div className="hidden w-max gap-4 lg:flex [&_span]:text-sm">
          <AppStoreButton
            title={labels[LabelKey.postReservationCampusConnectSection_appStoreCtaEyebrowText]}
            url={getCampusConnectAppStoreUrl(userMarket)}
            theme="light"
            height={60}
          />
          <GooglePlayButton
            title={labels[LabelKey.postReservationCampusConnectSection_googlePlayEyebrowText]}
            url={getCampusConnectGooglePlayUrl(userMarket)}
            theme="light"
            height={60}
          />
        </div>
      </div>

      <div className="pointer-events-none -mx-8 -mb-8 max-h-[250px] shrink-0 basis-[250px] [clip-path:inset(-250px_0_0_0)] lg:-mb-0 lg:max-h-max lg:overflow-hidden lg:[clip-path:none]">
        <img
          className="relative translate-x-28 -rotate-12 scale-110 lg:-left-1/3 lg:h-[480px] lg:translate-x-0 lg:rotate-12 lg:scale-100"
          src={BACKGROUND_IMG_URL}
          alt="Campus Connect"
        />
      </div>
    </Surface>
  );
};

export default PostSubmissionContent;
